
import { BookYear } from "@/models/book-year";
import Vue from "vue";
export default Vue.extend({
	props: {
		year: {
			type: Object as ()=>BookYear,
			required: true
		}
	},
	computed: {
		createdYear():number{
			return this.year.Year;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	}
});
